import { AuxiliumComponent } from "../auxilium-component";

export class Grid extends AuxiliumComponent {
	constructor() {
		super();

		this.gap = this.getAttribute("gap") ?? "";

		this.columns = parseInt(this.getAttribute("columns")) || 0;
		this.columnsSmall = parseInt(this.getAttribute("columns-sm")) || 0;
		this.columnsMedium = parseInt(this.getAttribute("columns-md")) || 0;
		this.columnsLarge = parseInt(this.getAttribute("columns-lg")) || 0;
		this.columnsExtraLarge = parseInt(this.getAttribute("columns-xl")) || 0;
		this.columnsExtraExtraLarge = parseInt(this.getAttribute("columns-xxl")) || 0;

		if (!this.id) { this.id = `cg${crypto.randomUUID().slice(0, 8)}`; }
	}

	parsedCallback() {
		if ([this.columns, this.columnsSmall, this.columnsMedium].some(x => x)) {
			let sheet = (document.getElementById("stAuxilium") ?? document.head.appendChild(document.createElementWithContents("style", null, { id: "stAuxilium" }))).sheet,
				rule = `#${this.id} {`;

			if (this.columns) { rule += `--grid-columns: ${this.columns};`; };
			if (this.columnsSmall) { rule += `--grid-columns-sm: ${this.columnsSmall};`; };
			if (this.columnsMedium) { rule += `--grid-columns-md: ${this.columnsMedium};`; };
			if (this.columnsLarge) { rule += `--grid-columns-lg: ${this.columnsLarge};`; };
			if (this.columnsExtraLarge) { rule += `--grid-columns-xl: ${this.columnsExtraLarge};`; };
			if (this.columnsExtraExtraLarge) { rule += `--grid-columns-xxl: ${this.columnsExtraExtraLarge};`; };

			sheet.insertRule(rule + "}", sheet.cssRules.length);
		}

		const list = document.createElementWithContents("ul", [...this.childNodes ?? []].filter(x => x.nodeType !== Node.TEXT_NODE || x.textContent.trim())
			.map(child => document.createElementWithContents("li", child)));

		this.appendChild(list);
	}
}